//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";
import { GetAppointmentDate, GetMonthName, GetYear } from "../../../core/datehelper";

export const Observation = createAsyncThunk(
  "Observation",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingObservation(""));
      const response = await UsePortalApi(
        `Patient/Observation`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
        dispatch(
          gettingObservationSuccess(
            response
          )
        );
        // gettingFormat(response)
      } else {
        dispatch(
          gettingObservationFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingObservationFailed(error));
    }
  }
);



const gettingFormat=(json )=> {
    var dataArray = json[0].entry

    let copyOfDataArray = json[0].entry
    let sortedArray = copyOfDataArray.sort(function (a, b) {
        // descemding order base on date and time
        // if need ascending order need to change the a with b and vice versa in the return not in the function arg
        return (new Date(a.resource.extension[0].valueDateTime) - new Date(b.resource.extension[0].valueDateTime));
        // return new Date(b.dateCreated) - new Date(a.dateCreated);
    });

    var graphdataArray = [{
        data: [],
        labels: [],
        text: [],
        name: '',
        id: 1
    },
    {
        data: [],
        labels: [],
        text: [],
        name: '',
        id: 2
    },
    {
        data: [],
        labels: [],
        text: [],
        name: '',
        id: 3
    },
    {
        data: [],
        labels: [],
        text: [],
        name: '',
        id: 4
    },
    {
        data: [],
        labels: [],
        text: [],
        name: '',
        id: 5
    }];

    sortedArray.map((item, key) => {

        var ob = {
            text: item.resource.code.coding[0].display,
            value: item.resource.component[0].valueQuantity.value,
            inserteddate: item.resource.extension[0].valueDateTime
        };

        switch (ob.text) {
            case "Blood Pressure":
                if (graphdataArray[0].name === "") {
                    graphdataArray[0].name = "Blood Pressure"
                }
                graphdataArray[0].data.push(ob.value);
                graphdataArray[0].text.push(ob.text)
                graphdataArray[0].labels.push(GetAppointmentDate(ob.inserteddate) + " " + GetMonthName(ob.inserteddate) + " " + GetYear(ob.inserteddate));
                break;
            case "Weight":
                if (graphdataArray[1].name === "") {
                    graphdataArray[1].name = "Weight"
                }
                // console.log("wieght\n " + "\n" + key + "\n" + ob.value + "\n" + ob.text)
                graphdataArray[1].data.push(ob.value);
                graphdataArray[1].text.push(ob.text)
                graphdataArray[1].labels.push(GetAppointmentDate(ob.inserteddate) + " " + GetMonthName(ob.inserteddate) + " " + GetYear(ob.inserteddate));
                break;
            case "BMI":
                if (graphdataArray[2].name === "") {
                    graphdataArray[2].name = "BMI"
                }
                graphdataArray[2].data.push(ob.value);
                graphdataArray[2].text.push(ob.text)
                graphdataArray[2].labels.push(GetAppointmentDate(ob.inserteddate) + " " + GetMonthName(ob.inserteddate) + " " + GetYear(ob.inserteddate));
                break;
            case "Height":
                if (graphdataArray[3].name === "") {
                    graphdataArray[3].name = "Height"
                }
                graphdataArray[3].data.push(ob.value);
                graphdataArray[3].text.push(ob.text)
                graphdataArray[3].labels.push(GetAppointmentDate(ob.inserteddate) + " " + GetMonthName(ob.inserteddate) + " " + GetYear(ob.inserteddate));
                break;
            case "Heart Rate":
                if (graphdataArray[4].name === "") {
                    graphdataArray[4].name = "Heart Rate"
                }
                graphdataArray[4].data.push(ob.value);
                graphdataArray[4].text.push(ob.text)
                graphdataArray[4].labels.push(GetAppointmentDate(ob.inserteddate) + " " + GetMonthName(ob.inserteddate) + " " + GetYear(ob.inserteddate));
                break;
            default:
                return;
        }

    })


    let graphdata = [];
    graphdataArray.map((value, index) => {
        // if some indix has no data then leve it and push the data contain index into the graphdata array
        if (value.name) {
            graphdata.push(value)
            // console.log("name==>" + value.name)
        } else {
            // 
        }
    })



    let wholeArrays = {
        // gradphData: grad,
        gradphData: graphdata,

    }
   return (wholeArrays.gradphData)
}
const ObservationSlice = createSlice({
  name: "Observation",
  initialState: {
    wholeArray: null,
    isLoading: false,
    error: false,
  },
  reducers: {
    gettingObservation: (state, action) => {
      state.wholeArray = null;
      state.isLoading = true;
      state.error = false;
    },
    gettingObservationSuccess: (state, action) => {
      state.wholeArray = gettingFormat( action.payload);
      state.isLoading = false;
      state.error = false;
    },
    gettingObservationFailed: (state, action) => {
      state.wholeArray = null;
      state.isLoading = false;
      state.error = true;
    },
    gettingObservationClear: (state, action) => {
      state.wholeArray = null;
      state.isLoading = false;
      state.error = false;
    },
  },
});
export const {
  gettingObservation,
  gettingObservationSuccess,
  gettingObservationFailed,
  gettingObservationClear,
} = ObservationSlice.actions;
export default ObservationSlice.reducer;
